import { useEffect, useState } from "react";
import { useGoPage } from "../../hooks/useGoPage";
import "./style.css"

import cart_icon from './../../assets/svg/basket.svg';

function Orders() {
    const goPage = useGoPage();

    const [year, setYear] = useState(String(new Date().getFullYear()));
    const [search, setSearch] = useState('');
    const [filters, setFilters] = useState({ month: 'all', status: 'all' });

    const [page, setPage] = useState(1);
    const [inSubmit, setInSubmit] = useState(false);
    const [showOrder, setShowOrder] = useState(null);
    const [ordersList, setOrdersList] = useState([]);
    const [ordersFiltered, setOrdersFiltered] = useState([]);
    const [counters, setCounters] = useState({ sent: 0, paid: 0 });

    const PAGE_SIZE = 25;

    useEffect(() => {
        const fetchOrders = async () => {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/payements/orders/${year}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token_vanrah')}` }
            });
            const data = await res.json();
            if (!res.ok) return alert(data.message);
            setOrdersList(data);
        };
        if (year) fetchOrders();
    }, [year]);

    useEffect(() => {
        if (!ordersList.length) {
            setOrdersFiltered([]);
            setCounters({ sent: 0, paid: 0 });
            return;
        }

        let filtered = ordersList;

        if (filters.month !== 'all') {
            filtered = filtered.filter(o => {
                return new Date(o.createdAt).getMonth() + 1 === Number(filters.month);
            });
        }
        if (filters.status !== 'all') {
            filtered = filtered.filter(o => o.status === filters.status);
        }
        if (search.trim()) {
            const s = search.toLowerCase();
            filtered = filtered.filter(
                o =>
                    o.firstname?.toLowerCase().includes(s) ||
                    o.lastname?.toLowerCase().includes(s) ||
                    o.email?.toLowerCase().includes(s)
            );
        }

        const start = (page - 1) * PAGE_SIZE;
        const paged = filtered.slice(start, start + PAGE_SIZE);

        setOrdersFiltered(paged);

        const c = { sent: 0, paid: 0 };
        filtered.forEach(o => {
            if (o.status === 'sent') c.sent++;
            if (o.status === 'paid') c.paid++;
        });
        setCounters(c);
    }, [ordersList, filters, search, page]);

    const handleYear = e => setYear(e.target.value);
    const handleMonth = e => setFilters(f => ({ ...f, month: e.target.value }));
    const handleStatus = e => setFilters(f => ({ ...f, status: e.target.value }));
    const handleSearch = e => setSearch(e.target.value);

    const updateStatus = async (e, order) => {
        if (inSubmit) return alert('Veuillez patientez...')
        setInSubmit(true);
        const newStatus = e.target.value;

        const req = await fetch(`${process.env.REACT_APP_API_URL}/payements/order/${order._id}/${newStatus}`, {
            method: 'PUT',
            headers: { Authorization: `Bearer ${localStorage.getItem('token_vanrah')}` }
        });
        const res = await req.json();
        setInSubmit(false);

        if (req.status !== 200) {
            alert(res.message);
            return
        }

        const newOrdersList = ordersList.map(o => o._id === order._id ? { ...o, status: newStatus } : o)
        setOrdersList(newOrdersList);

        if (showOrder) {
            setShowOrder({ ...showOrder, status: newStatus });
        }
    }

    return page && (
        <div className='page page_orders'>
            <button
                className="btn_new_item"
                onClick={() => goPage('delivery')}
            >
                <i className="far fa-pen-to-square"></i>
                tarifs de livraison
            </button>

            <p className='title_page'>- <span>Commandes</span> -</p>

            <div className="counters">
                <p>Commandes envoyées : <span>{counters.sent}</span></p>
                <p>Commande à faire : <span>{counters.paid}</span></p>
            </div>

            <section className="sect_orders">
                <div className="panel_filters">
                    <div className="filters">
                        {/*----- Année -----*/}
                        <div className="filter">
                            <span>Année :</span>
                            <select value={year} onChange={handleYear}>
                                {Array.from(
                                    { length: new Date().getFullYear() - 2026 + 1 },
                                    (_, i) => 2026 + i
                                ).map(y => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </select>
                        </div>

                        {/*----- Mois -----*/}
                        <div className="filter">
                            <span>Mois :</span>
                            <select value={filters.month} onChange={handleMonth}>
                                <option value="all">All</option>
                                {Array.from({ length: 12 }, (_, i) => {
                                    const num = String(i + 1).padStart(2, '0');
                                    const lab = new Date(2020, i).toLocaleDateString('fr-FR', { month: 'long' });
                                    return <option key={num} value={num}>{num} {lab}</option>;
                                })}
                            </select>
                        </div>

                        {/*----- Statut -----*/}
                        <div className="filter">
                            <span>Status :</span>
                            <select value={filters.status} onChange={handleStatus}>
                                <option value="all">All</option>
                                <option value="unpaid">impayé</option>
                                <option value="paid">en cours</option>
                                <option value="back">remboursé</option>
                                <option value="sent">envoyé</option>
                            </select>
                        </div>
                    </div>

                    <div className="search_bar">
                        <input
                            type="text"
                            value={search}
                            placeholder="Recherche par nom/prénom/email"
                            onChange={handleSearch}
                        />
                        <i className="fa-solid fa-magnifying-glass"></i>
                    </div>
                </div>

                {ordersFiltered.length !== 0 &&
                    <div className="table">
                        <div className="th">
                            <p className="name_order">Nom</p>
                            <p className="name_order">Prénom</p>
                            <p className="email_order">Email</p>
                            <p className="some_order">Total</p>
                            <p className="cart_order">Panier</p>
                            <p className="status_order">Status</p>
                        </div>

                        {ordersFiltered.map((o, idx) => (
                            <div key={idx} className="row">
                                <p className="name_order">{o.lastname}</p>
                                <p className="name_order">{o.firstname}</p>
                                <p className="email_order">{o.email}</p>
                                <p className="some_order">{o.some}€</p>

                                <button
                                    className="cart_order"
                                    onClick={() => setShowOrder(o)}
                                >
                                    <img src={cart_icon} alt="" />
                                </button>

                                <select
                                    className="status_order"
                                    value={o.status}
                                    onChange={(e) => updateStatus(e, o)}
                                >
                                    <option value="unpaid">impayé</option>
                                    <option value="paid">en cours</option>
                                    <option value="back">remboursé</option>
                                    <option value="sent">envoyé</option>
                                </select>
                            </div>
                        ))}
                    </div>
                }

                {ordersFiltered.length > 25 &&
                    <div className="panel_table_orders">
                        <button
                            onClick={() => setPage(p => Math.max(1, p - 1))}
                            disabled={page === 1}
                        >Précédent</button>

                        <span>Page {page}</span>

                        <button
                            onClick={() => setPage(p => p + 1)}
                            disabled={ordersFiltered.length < PAGE_SIZE}
                        >Suivant</button>
                    </div>
                }

                {ordersFiltered.length === 0 &&
                    <div className="table">
                        <p className="table_empty">Aucune commande trouvée.</p>
                    </div>
                }
            </section >

            {showOrder &&
                <div className="mdl_order">
                    <button
                        className="close_order"
                        onClick={() => setShowOrder(null)}
                    ><i className="fas fa_xmark"></i></button>

                    <div className="content">
                        <span className="title_mdl">Commande</span>

                        <div className="infoClient">
                            <p><span>Nom :</span>{showOrder.lastname}</p>
                            <p><span>Prénom :</span>{showOrder.firstname}</p>
                            <p><span>Email :</span>{showOrder.email}</p>
                            <p><span>Adresse :</span>{showOrder.address}</p>
                            <p><span>Ville :</span>{showOrder.city}</p>
                            <p><span>Code postale :</span>{showOrder.zip_code}</p>
                            <p><span>Pays :</span>{showOrder.country}</p>
                        </div>

                        <div className="list">
                            <ul className="cart_list">
                                {showOrder.card.map((item, idx) => (
                                    <li key={idx} className="cart_item">
                                        <p>{item.title} {item.selector ? `(${item.selector})` : ''}</p>
                                        <p>{item.quantity} x {item.price}€</p>
                                    </li>
                                ))}
                            </ul>

                            <div className="total_line">
                                <span>Total</span>
                                <span>{showOrder.some.toFixed(2)} €</span>
                            </div>
                        </div>

                        <div className="panel_modal">
                            <button
                                className="btn_close"
                                onClick={() => setShowOrder(null)}
                            >Fermer</button>


                            <select
                                className="status_order"
                                value={showOrder.status}
                                onChange={(e) => updateStatus(e, showOrder)}
                            >
                                <option value="unpaid">impayé</option>
                                <option value="paid">en cours</option>
                                <option value="back">remboursé</option>
                                <option value="sent">envoyé</option>
                            </select>
                        </div>
                    </div>
                </div>
            }
        </div >
    );
}
export default Orders;